import React, { useState } from "react";
import {
  TextField,
  Grid,
  InputLabel,
  Stack,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { RegisterService } from "../../Service/_index";
import { ToastError } from "../../UiComponents/Toaster/Toast";
import swal from "../../Shared/swal";
import { motion, AnimatePresence } from "framer-motion";
import AnimatedBtnLoader from "../Login/AnimatedBtnLoader";

const ClientSignUp = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const SignupSchema = Yup.object().shape({
    name: Yup.string().min(1, "Too Short!").required("Enter Name"),
    email: Yup.string().email("Invalid email").required("Enter your email"),
    mobileNumber: Yup.string().required("Enter your mobile Number"),
    newPassword: Yup.string().required("Password is Required"),
    confirmPassword: Yup.string()
      .oneOf(
        [Yup.ref("newPassword"), null],
        'Must match "password" field value'
      )
      .required("Enter Confirm Password"),
    onlinePolicyUserName: Yup.string().required("Enter Online Policy User Name"),
    onlinePolicyPassword: Yup.string().required("Enter Online Policy Password"),
  });

  const RegisterOnSubmit = (data) => {
    setIsLoading(true);
    RegisterService({
      name: data.name,
      mobileNumber: data.mobileNumber,
      email: data.email,
      password: data.newPassword,
      onlinePolicyUserName: data.onlinePolicyUserName,
      onlinePolicyPassword: data.onlinePolicyPassword,
    })
      .then((res) => {
        setIsLoading(false);
        if (res?.response?.status === 500) {
          ToastError(res.response.data.message);
        } else {
          swal({
            title: "Registered Successfully!",
            text: "Client registered successfully",
            icon: "success",
            buttons: false,
          });
          // window.location.reload(); // Maybe not needed if we want to stay on page or navigate
        }
      })
      .catch((err) => {
        setIsLoading(false);
        ToastError(err.message);
      });
  };

  return (
    <div style={{ padding: "20px" }}>
        <Typography variant="h5" sx={{ mb: 3, fontWeight: "bold" }}>
             Client Registration
        </Typography>
      <Formik
        initialValues={{
          name: "",
          email: "",
          mobileNumber: "",
          newPassword: "",
          confirmPassword: "",
          onlinePolicyUserName: "",
          onlinePolicyPassword: "",
        }}
        validationSchema={SignupSchema}
        onSubmit={(values, { resetForm }) => {
          RegisterOnSubmit(values);
          resetForm();
        }}
      >
        {({ errors, touched, values }) => (
          <Form style={{ width: "100%", maxWidth: "600px" }} autoComplete="off">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <InputLabel
                  sx={{
                    color: "black",
                    fontFamily: "Inter",
                    marginBottom: "7px",
                  }}
                >
                  Name<span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Field
                  as={TextField}
                  name="name"
                  placeholder="Name"
                  fullWidth
                  variant="outlined"
                  autoComplete="new-name"
                  sx={{ pb: 2 }}
                />
                {errors.name && touched.name ? (
                  <div style={{ color: "red", fontSize: "12px" }}>{errors.name}</div>
                ) : null}
              </Grid>
              <Grid item xs={12} sm={6}>
                <InputLabel
                  style={{
                    color: "black",
                    fontFamily: "inter",
                    marginBottom: "7px",
                  }}
                >
                  Email
                  <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Field
                  as={TextField}
                  name="email"
                  fullWidth
                  variant="outlined"
                  placeholder="Email"
                  autoComplete="new-email"
                  sx={{ pb: 2 }}
                />
                {errors.email && touched.email ? (
                   <div style={{ color: "red", fontSize: "12px" }}>{errors.email}</div>
                ) : null}
              </Grid>

              <Grid item xs={12}>
                <InputLabel
                  style={{
                    color: "black",
                    fontFamily: "inter",
                    marginBottom: "7px",
                  }}
                >
                  Mobile Number
                  <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Field
                  as={TextField}
                  name="mobileNumber"
                  fullWidth
                  variant="outlined"
                  placeholder="Mobile number"
                  autoComplete="new-phone"
                  sx={{ pb: 2 }}
                />
                 {errors.mobileNumber && touched.mobileNumber ? (
                   <div style={{ color: "red", fontSize: "12px" }}>{errors.mobileNumber}</div>
                ) : null}
              </Grid>

              <Grid item xs={12} sm={6}>
                <InputLabel
                  style={{
                    color: "black",
                    fontFamily: "inter",
                    marginBottom: "7px",
                  }}
                >
                  Password
                  <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Field
                  as={TextField}
                  name="newPassword"
                  fullWidth
                  placeholder="Password"
                  type={showPassword ? "text" : "password"}
                  variant="outlined"
                  autoComplete="new-password"
                  sx={{ pb: 2 }}
                />
                 {errors.newPassword && touched.newPassword ? (
                   <div style={{ color: "red", fontSize: "12px" }}>{errors.newPassword}</div>
                ) : null}
              </Grid>
              <Grid item xs={12} sm={6}>
                <InputLabel
                  style={{
                    color: "black",
                    fontFamily: "inter",
                    marginBottom: "7px",
                  }}
                >
                  Confirm Password
                  <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Field
                  as={TextField}
                  name="confirmPassword"
                  fullWidth
                  type={showPassword ? "text" : "password"}
                  variant="outlined"
                  placeholder="Re-Enter Password"
                  autoComplete="new-password"
                  sx={{ pb: 2 }}
                />
                {errors.confirmPassword && touched.confirmPassword ? (
                   <div style={{ color: "red", fontSize: "12px" }}>{errors.confirmPassword}</div>
                ) : null}
              </Grid>

              <Grid item xs={12} sm={6}>
                <InputLabel
                  style={{
                    color: "black",
                    fontFamily: "inter",
                    marginBottom: "7px",
                  }}
                >
                  Online Policy User Name
                  <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Field
                  as={TextField}
                  name="onlinePolicyUserName"
                  fullWidth
                  variant="outlined"
                  placeholder="Online Policy User Name"
                  autoComplete="off"
                  sx={{ pb: 2 }}
                />
                {errors.onlinePolicyUserName && touched.onlinePolicyUserName ? (
                   <div style={{ color: "red", fontSize: "12px" }}>{errors.onlinePolicyUserName}</div>
                ) : null}
              </Grid>
              <Grid item xs={12} sm={6}>
                <InputLabel
                  style={{
                    color: "black",
                    fontFamily: "inter",
                    marginBottom: "7px",
                  }}
                >
                  Online Policy Password
                  <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Field
                  as={TextField}
                  name="onlinePolicyPassword"
                  fullWidth
                  variant="outlined"
                  placeholder="Online Policy Password"
                  autoComplete="off"
                  sx={{ pb: 2 }}
                />
                {errors.onlinePolicyPassword && touched.onlinePolicyPassword ? (
                   <div style={{ color: "red", fontSize: "12px" }}>{errors.onlinePolicyPassword}</div>
                ) : null}
              </Grid>
            </Grid>

            <FormControlLabel
              control={
                <Checkbox
                  checked={showPassword}
                  onChange={() => setShowPassword(!showPassword)}
                />
              }
              label="Show Password"
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontFamily: "inter",
                  fontWeight: "400 !important",
                  fontSize: "14px",
                },
                mb: 2
              }}
            />

            <AnimatedBtnLoader
              buttonText={"Create Client"}
              disabled={isLoading}
              type="submit"
            />
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ClientSignUp;
